const searchResults = {
    mixins: [mixins],
    data() {
        return {
            value: "",
            tabs: [],
            tab: null,
            tabItem: null,
            handler: "",
            errorMsgs: [],
            records: [],
            loading: true,
            page: 1,
            allItems:0
        };
    },
    mounted() {
        
    },
    methods: {
        reset(){
            this.records = []
            this.page = 1
        },
        changeTab(newTab){
            api.fn.moveWindowToObj(jQuery('.s-search-results'), 0, ()=>{
                this.$refs["tabs"].changeTab(newTab)
            })
            
        },
        tabChanged(newTab) {
            this.reset()

            this.tab = newTab;            
            this.tabItem = this.tabs.filter(x => x.id === newTab)[0]
            
            this.setLazy()

            if(this.tabItem.type !== "group"){
                this.doSearch()
            }
        },
        doSearch(){
            this.loading = true;
            this.errorMsgs = [];


            try {
                axios
                    .post(this.handler, { value: this.tab, page: this.page })
                    .then((response) => {
                        var { hasError, errorMessages, data, allItems } = response.data;

                        if (hasError) {
                            this.handleError(errorMessages);
                            return false;
                        }

                        this.handleSuccess(data, allItems);
                    })
                    .catch((errors) => {
                        this.handleError([this.globalerror]);
                    })
                    .then(() => {
                        this.loading = false;
                    });
            } catch (err) {
                this.loading = false;
                this.handleError(JSON.parse(err));
            }

        
        },
        handleError(messages) {
            this.errorMsgs = this.hasValue(messages) ? messages : [];
        },
        handleSuccess(data, allItems) {
            this.records = [];

            this.$nextTick(()=>{
                this.allItems = parseInt(allItems)
                this.records = [].concat(...data);
            })

            
        },
        pageChanged(newPage){
            this.page = newPage

            if(this.tabItem.type !== "group"){
                this.doSearch()
                this.scrollToElem(jQuery(this.$el))
            }
        },
        setLazy(){
            this.$nextTick(()=>{
                jQuery(this.$el).find('[data-src]').lazy();
            })
        },
        cardBg(card) {
            if (card !== null && card.bg && card.bg !== "") {
                return card.bg;
            }
            return "";
        }
    },
    computed:{
    }
};

var searchResultsApp = Vue.createApp(searchResults);
if (document.querySelector("#search-results")) {
    searchResultsApp.directive("init", initDirective);
    searchResultsApp.component("search-input", searchInput);
    searchResultsApp.component("b-auto-completer", bAutoCompleter);
    searchResultsApp.component("b-tabs", bTabs);
    searchResultsApp.component('b-pagination', bPagination);
    searchResultsApp.mount("#search-results");
}
